import { MobileHeader } from 'src/components/MobileView/components/MobileHeader';
import { MyCommunities as MyCommunitiesContent } from 'src/components/MyCommunities';
import React from 'react';
import { TMyCommunitiesProps } from './MyCommunities.types';
import s from './MyCommunities.module.scss';

export const MyCommunities: React.FC<TMyCommunitiesProps> = () => {
  return (
    <div className={s.container}>
      <MobileHeader headerTitle="My Communities" />
      <MyCommunitiesContent />
    </div>
  );
};
